import { useState } from 'react';
import { toast } from 'react-toastify';
import { addCampaign } from '@/store/Campaign';

const formatDate = (input: string) => {
  const d = new Date(input);
  return `${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}/${d.getFullYear()}`;
};

const useCampaignSubmit = ({ form, dispatch, stripe, elements }: any) => {
  const [open, setOpen] = useState(false);

  const handleSubmit = async () => {
    const amount = form.totalDays * form.dailyBudget * 100;
    if (amount <= 1) return toast.error('Minimum budget must be over $2');

    try {
      // Prepare campaign data
      const locationData = form.locations.map((loc: any) => ({
        mapboxId: loc.mapbox_id,
        countryCode: loc.country.country_code,
        sessionToken: loc.session_token,
      }));

      const campaignData = {
        audienceTitle: form.newAudienceName,
        minAge: form.newAgeRange[0],
        maxAge: form.newAgeRange[1],
        gender: form.newGender.map((g: string) => g.toLowerCase()),
        location: locationData,
        campaignTitle: form.campaignName,
        gamicId: form.selectedGameId,
        startDate: formatDate(form.startDate),
        endDate: formatDate(form.endDate),
        dailyBudget: form.dailyBudget,
        audienceId: form.selectedAudienceId,
      };

      toast.info('Submitting Campaign...');
      const res = await dispatch(addCampaign(campaignData));
      if (res.error) {
        toast.error(`❌ Submission failed: ${res.error.message}`);
      } else {
        setOpen(true);
        toast.success('Campaign submitted successfully');
        setTimeout(() => {
          window.location.reload();
        }, 3000); // 2000 ms = 2 seconds
      }
    } catch (err: any) {
      console.error(err);
      toast.error(`❌ Submission failed: ${err.message || 'Unknown error'}`);
    }
  };

  return { handleSubmit, open, setOpen };
};

export default useCampaignSubmit;
